"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
// eslint-disable-next-line import/named
const react_dropzone_1 = require("react-dropzone");
const classnames_1 = __importDefault(require("classnames"));
const IconWrapper_1 = __importDefault(require("../Icons/IconWrapper"));
const HighlightedIcon_1 = __importStar(require("../HighlightedIcon"));
const DropzonePreview_1 = __importDefault(require("./DropzonePreview"));
const DropzoneErrors_1 = __importDefault(require("./DropzoneErrors"));
const MIMETypeSniffer_1 = require("./MIMETypeSniffer");
const types_1 = require("./types");
const Dropzone_helpers_1 = require("./Dropzone.helpers");
// Error codes which are not attributable to a specific file
const nonFileSpecificErrorCodes = [types_1.DropzoneErrorCode.TooFewFiles, types_1.DropzoneErrorCode.TooManyFiles];
const DropzoneBase = (_a) => {
    var { buttonLabel, descriptionLabel, enableMIMETypeSniffing, errors = [], errorsLabel, errorMessages, actions, files = [], helpLabel, disabled, noClick = false, readOnly = false, displayFileSize = false, hidePreviewInfos = false, onAddFiles, onRemoveFile, renderPreviewInfo, setErrors, setFiles, validations: { accept, maxFiles, minFiles, maxSizeBytes, minSizeBytes } } = _a, props = __rest(_a, ["buttonLabel", "descriptionLabel", "enableMIMETypeSniffing", "errors", "errorsLabel", "errorMessages", "actions", "files", "helpLabel", "disabled", "noClick", "readOnly", "displayFileSize", "hidePreviewInfos", "onAddFiles", "onRemoveFile", "renderPreviewInfo", "setErrors", "setFiles", "validations"]);
    const [isHoveringDropzone, setIsHoveringDropzone] = (0, react_1.useState)(false);
    const dropzoneAccept = accept === null || accept === void 0 ? void 0 : accept.reduce((acc, mimeType) => (Object.assign(Object.assign({}, acc), { [mimeType]: [] })), {});
    const maxFilesOnNextDrop = maxFiles - files.length;
    const setNewFilesState = (newFiles, newErrors = []) => {
        if (newFiles.length < minFiles && newErrors.length === 0) {
            newErrors.push({ code: types_1.DropzoneErrorCode.TooFewFiles, isStateError: true });
        }
        setFiles((prevFiles) => {
            if (prevFiles.length < newFiles.length) {
                const newFilesToAdd = newFiles.filter((file) => !prevFiles.includes(file));
                onAddFiles && onAddFiles(newFilesToAdd);
            }
            else {
                const fileToRemove = prevFiles.filter((file) => !newFiles.includes(file))[0];
                onRemoveFile && onRemoveFile(fileToRemove);
            }
            return newFiles;
        });
        setErrors(newErrors);
    };
    const removeFile = (file) => {
        const newFiles = [...files];
        newFiles.splice(newFiles.indexOf(file), 1);
        setNewFilesState(newFiles);
    };
    const onDrop = (acceptedFiles, fileRejections) => __awaiter(void 0, void 0, void 0, function* () {
        const newFiles = [...files];
        const newErrors = [];
        for (const fileRejection of fileRejections) {
            const { file, errors } = fileRejection;
            // File rejected only because the MIMEType returned by the native input is ""
            if (accept && errors.length === 1 && errors[0].code === types_1.DropzoneErrorCode.FileInvalidType && file.type === "") {
                const trueMIMETypes = yield new MIMETypeSniffer_1.MIMETypeSniffer(file).getMIMETypes();
                if (trueMIMETypes.some((type) => accept.includes(type))) {
                    newFiles.push(file);
                    continue;
                }
            }
            for (const error of errors) {
                const code = error.code;
                // Error codes which are not file-specific shouldn't be duplicated per file
                if (nonFileSpecificErrorCodes.includes(code) && newErrors.some((err) => err.code === code)) {
                    continue;
                }
                newErrors.push({ code, file });
            }
        }
        for (const acceptedFile of acceptedFiles) {
            // If MIME type sniffing is enabled, we will reject an otherwise accepted file if
            // its type doesn't match the actual MIME type determined by the MIMETypeSniffer
            if (enableMIMETypeSniffing) {
                const trueMIMETypes = yield new MIMETypeSniffer_1.MIMETypeSniffer(acceptedFile).getMIMETypes();
                if (!trueMIMETypes.includes(acceptedFile.type)) {
                    newErrors.push({
                        code: types_1.DropzoneErrorCode.SpoofedFileExtension,
                        file: acceptedFile,
                    });
                    continue;
                }
            }
            // Validate only by filename, because the file object might be different
            // depending where it comes from, making it useless for comparison
            const validatedFile = (0, Dropzone_helpers_1.validateDuplicateFilename)(newFiles, acceptedFile);
            newFiles.push(validatedFile);
        }
        setNewFilesState(newFiles, newErrors);
    });
    const dropzoneState = (0, react_dropzone_1.useDropzone)({
        disabled,
        onDrop,
        noClick,
        accept: dropzoneAccept,
        maxFiles: maxFilesOnNextDrop,
        maxSize: maxSizeBytes,
        minSize: minSizeBytes,
        multiple: maxFiles > 1,
    });
    const { getRootProps, getInputProps, open: openFileSelector, isDragActive } = dropzoneState;
    const stateErrors = errors.filter(({ isStateError }) => isStateError);
    const otherErrors = errors.filter(({ isStateError }) => !isStateError);
    const hasErrors = Boolean(otherErrors.length || stateErrors.length);
    const hasFiles = files.length > 0;
    const hasMaxFiles = files.length >= maxFiles;
    const hasStateErrors = stateErrors.length > 0;
    const isActive = isDragActive || (!noClick && isHoveringDropzone);
    return (react_1.default.createElement("div", { className: "gerudo-dropzone", "data-testid": props["data-testid"] },
        !readOnly && (react_1.default.createElement(react_1.default.Fragment, null,
            !hasMaxFiles && (react_1.default.createElement("div", Object.assign({ onMouseEnter: () => setIsHoveringDropzone(true), onMouseLeave: () => setIsHoveringDropzone(false), className: (0, classnames_1.default)("dropzone", {
                    disabled,
                    clickable: !noClick,
                    "is-active": isActive,
                    "has-errors": hasStateErrors,
                }) }, getRootProps()),
                react_1.default.createElement("input", Object.assign({}, getInputProps())),
                react_1.default.createElement("div", { className: "dropzone-content" },
                    react_1.default.createElement(HighlightedIcon_1.default, { className: "dropzone-upload-icon", type: isActive
                            ? HighlightedIcon_1.HighlightedIconType.Info
                            : hasStateErrors
                                ? HighlightedIcon_1.HighlightedIconType.Danger
                                : HighlightedIcon_1.HighlightedIconType.Default },
                        react_1.default.createElement(IconWrapper_1.default, { name: "UploadCloud" })),
                    descriptionLabel && (react_1.default.createElement("p", { className: "dropzone-description" },
                        react_1.default.createElement("span", null, descriptionLabel),
                        buttonLabel && (react_1.default.createElement("button", { className: "dropzone-open", onClick: noClick ? openFileSelector : undefined, type: "button" }, buttonLabel))))))),
            helpLabel && react_1.default.createElement("div", { className: "dropzone-help" }, helpLabel),
            hasErrors && (react_1.default.createElement(DropzoneErrors_1.default, { otherErrors: otherErrors, stateErrors: stateErrors, errorsLabel: errorsLabel, errorMessages: errorMessages, setErrors: setErrors })))),
        !hidePreviewInfos && hasFiles && (react_1.default.createElement("div", { className: "dropzone-previews" }, files.map((file, index) => (react_1.default.createElement(DropzonePreview_1.default, { key: file.name + index, file: file, displayFileSize: displayFileSize, onRemovePreview: removeFile, renderPreviewInfo: renderPreviewInfo, actions: actions, readOnly: readOnly })))))));
};
exports.default = DropzoneBase;
//# sourceMappingURL=DropzoneBase.js.map